import CrossIconError from '@/assets/svg/CrossIconError';
import CrossIconSuccess from '@/assets/svg/CrossIconSuccess';
import { twMerge } from 'tailwind-merge';

type CrossItemProps = {
  className?: string;
  isSuccess?: boolean;
};

const CrossItem = ({ className, isSuccess = true }: CrossItemProps) => {
  return (
    <div className={twMerge('relative size-[30px] shrink-0 w-full', className)}>
      {isSuccess ? <CrossIconSuccess /> : <CrossIconError />}
      <div className="absolute leading-none left-2/4 top-2/4 -translate-y-2/4 -translate-x-2/4">
        <i
          className={twMerge(
            'ki-filled text-lg ps-px',
            isSuccess
              ? 'ki-check text-green-11BFA4'
              : 'ki-cross text-red-F8275A'
          )}
        />
      </div>
    </div>
  );
};

export default CrossItem;
